import { basicEnum } from "./base";

export const ProvisionItemReturnStatusEnum = basicEnum([
    {
        label: "KEMBALI",
        value: "R", // Returned
    },
    {
        label: "HILANG",
        value: "L", // Lost
    },
]);

export namespace ProvisionItemReturnStatusEnum {
    export type Labels = (typeof ProvisionItemReturnStatusEnum)["labels"][number];
    export type Values = (typeof ProvisionItemReturnStatusEnum)["values"][number];
}
